import React from 'react';
import { CaseStudyCard } from './CaseStudyCard';
import { caseStudies } from '../data/caseStudies';
type AdjacentCaseStudiesProps = {
  currentId: string;
};
export function AdjacentCaseStudies({
  currentId
}: AdjacentCaseStudiesProps) {
  const index = caseStudies.findIndex(s => s.id === currentId);
  if (index === -1 || caseStudies.length < 2) return null;
  const count = caseStudies.length;
  const previous = caseStudies[(index - 1 + count) % count];
  const next = caseStudies[(index + 1) % count];
  const items = previous.id === next.id ? [previous] : [previous, next];
  return <section aria-labelledby="more-case-studies" className="flex w-full max-w-[1347px] flex-col gap-5 px-5 md:px-10" data-id="element-19" data-mp="2r0w1nvrzs9sv">
      <h2 id="more-case-studies" className="text-xl font-semibold" data-id="element-20" data-mp="2vyee3w57x75m">
        More case studies
      </h2>
      <div className="grid grid-cols-1 gap-[30px] md:grid-cols-2" data-id="element-21" data-mp="1fkefcoi3znjy">
        {items.map(study => <CaseStudyCard key={study.id} study={study} size="compact" data-id="element-22" data-mp="1kl2391b1jo9y" />)}
      </div>
    </section>;
}